import { render, staticRenderFns } from "./PurchaseContract.vue?vue&type=template&id=caa1ecc0&scoped=true&"
import script from "./PurchaseContract.vue?vue&type=script&lang=js&"
export * from "./PurchaseContract.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseContract.vue?vue&type=style&index=0&id=caa1ecc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa1ecc0",
  null
  
)

export default component.exports